module.exports = __webpack_public_path__ + "static/media/course_2.9ca790d4.mp4";